module.exports = __webpack_public_path__ + "static/media/startman.14418306.svg";